/// <amd-module name="Test/AssociateToTestCase/Source/AssociateToTestCaseSource" />
import * as TestManagementService from "Test/Client/TestManagementServices";
import { TestCaseResultIdentifier } from "Test/common-util/Common";
import * as TCMContracts from "Test/common-util/Contracts/Test";
import { IVssPageContext } from "VSS/Platform/Context";
import { IWorkItemTrackingRestClient } from 'Wit/Clients/Wit/RestClient/WorkItemTracking.Types';
import { Wiql, WorkItem, WorkItemQueryResult } from 'Wit/Clients/Wit/Contracts/WorkItemTracking';

export class AssociateToTestCaseSource {
    private static _instance: AssociateToTestCaseSource;

    public static getInstance(): AssociateToTestCaseSource {
        if (AssociateToTestCaseSource._instance) {
            return AssociateToTestCaseSource._instance;
        }
        AssociateToTestCaseSource._instance = new AssociateToTestCaseSource();
        return AssociateToTestCaseSource._instance;
    }

    private _detailedTestResultCache: any = {};

    private getWorkItemTrackingClient(pageContext: IVssPageContext) {
        return pageContext.getRestClient<IWorkItemTrackingRestClient>("IWorkItemTrackingRestClient");
    }

    public getSelectedTestCaseResult(context: IVssPageContext, runId: number, resultId: number): Promise<TCMContracts.TestCaseResult> {
        const testCaseResultIdentifier = new TestCaseResultIdentifier(runId, resultId).toString();
        return new Promise<TCMContracts.TestCaseResult>((resolve, reject) => {
            if (this._detailedTestResultCache[testCaseResultIdentifier]) {
                resolve(this._detailedTestResultCache[testCaseResultIdentifier]);
            } 
            else {
                const tcmService = context.getService<TestManagementService.ITestManagementService>(TestManagementService.TestManagementServiceName);
                tcmService
                    .getResultById(runId, resultId, TCMContracts.ResultDetails.SubResults)
                    .then((value: TCMContracts.TestCaseResult) => {
                        this._detailedTestResultCache[testCaseResultIdentifier] = value;
                        resolve(value);
                    })
                    .catch((reason: any) => {
                        reject(reason);
                    });
            }
        });
    }

    public async getHashedValue(automatedTestName: string, pageContext: IVssPageContext): Promise<string>{
        const buffer = new TextEncoder().encode(automatedTestName);
        const hashBuffer = await window.crypto.subtle.digest('SHA-256', buffer);
        const hashArray = Array.from(new Uint8Array(hashBuffer));
      
        // Convert bytes to hexadecimal manually without padStart
        const hashedString = hashArray.map((byte) => {
          const hex = byte.toString(16);
          return hex.length === 1 ? '0' + hex : hex;
        }).join('');

        console.log("SHA-256 generated for the selectedTest: " + hashedString);
      
        return hashedString;
    }

    public async addAssociationToWorkItemAsync(workItemId: string , testId: string, name: string , storage: string, pageContext: IVssPageContext){
        let data = [];
        data.push({
            op: "add",
            path: "/fields/" + "Microsoft.VSTS.TCM.AutomatedTestId",
            value:testId
        });
        data.push({
            op: "add",
            path: "/fields/" + "Microsoft.VSTS.TCM.AutomatedTestName",
            value:name
        });
        data.push({
            op: "add",
            path: "/fields/" + "Microsoft.VSTS.TCM.AutomatedTestStorage",
            value:storage
        });

        await this.getWorkItemTrackingClient(pageContext).updateWorkItem(data, parseInt(workItemId)).then((workItems: WorkItem) => {
            console.log("updated the work item with association");
        });
    }

    public createWiqlQuery(testId: string): Wiql{
        const query = `Select [System.Id] From WorkItems Where System.WorkItemType IN GROUP 'Microsoft.TestCaseCategory' And Microsoft.VSTS.TCM.AutomatedTestId = '${testId}'`;
        return {query};
    }

    public async queryByWiqlAsync(pageContext: IVssPageContext, automatedTestName: string): Promise<WorkItem[]> {
        let workitemIds : number[] = [];
        let testId: string = "";
        return new Promise<WorkItem[]>(async (resolve, reject) => {
            this.getHashedValue(automatedTestName, pageContext).then( response => {
                testId = response;
                this.getWorkItemTrackingClient(pageContext).queryByWiql(this.createWiqlQuery(testId)).then((workItemQueryResult :WorkItemQueryResult) => {
                    workItemQueryResult.workItems.map(item => {
                        workitemIds.push(item.id);
                    })
                    if(workitemIds.length > 0){
                        this.getWorkItemTrackingClient(pageContext).getWorkItems(workitemIds).then((workItems: WorkItem[]) => {
                            resolve(workItems);
                        },
                            (error: Error) => {
                                console.log("Unable to load workitems");
                                console.log(error);
                                reject(error);
                            });
                    }
                    else {
                        console.log("No Associated WorkItems found");
                    }
                });
            });
        });
    }

    public async getWorkItemById(pageContext: IVssPageContext, workItemId: number): Promise<WorkItem> {
        return new Promise<WorkItem>((resolve, reject) => {
            this.getWorkItemTrackingClient(pageContext).getWorkItem(workItemId)
            .then((value: WorkItem) => {
                resolve(value);
            })
            .catch((reason: any) => {
                reject(reason);
            });
        });
    }
}